import { type UpdateUserSettingsResponse } from './aliases';

import {
  AUTH_IDENTIFY_ENDPOINT,
  PAYMENT_SETTINGS_ENDPOINT,
  PAYOUT_SETTINGS_ENDPOINT,
  PRESENTATION_USER_SETTINGS,
  USER_BALANCE,
  USER_COUNTERS_ENDPOINT,
} from '@/constants/endpoints';
import http, { typedHttp } from '@/modules/http';
import { replacePathParams } from '@/modules/http/replacePathParams';
import { type RequestBody } from '@/modules/http/type-helpers';
import { type AxiosCompatibleResponse } from '@/modules/http/types';
import { type FetchUserBalanceResponse } from '@/modules/user/types';

export function fetchUserCounters(userId: number) {
  return typedHttp.get(
    replacePathParams(USER_COUNTERS_ENDPOINT, { userId: String(userId) }),
    {
      withAuth: true,
    }
  );
}

export function fetchUserSettings() {
  return typedHttp.get(AUTH_IDENTIFY_ENDPOINT, { withAuth: true });
}

export function updateUserSettings(
  data: RequestBody<typeof PRESENTATION_USER_SETTINGS, 'patch'>
): Promise<AxiosCompatibleResponse<UpdateUserSettingsResponse>> {
  return typedHttp.patch(PRESENTATION_USER_SETTINGS, data, { withAuth: true });
}

export function getUserBalance(): Promise<AxiosCompatibleResponse<FetchUserBalanceResponse> | null> {
  return http.get(USER_BALANCE, { withAuth: true });
}

export function fetchUserPayoutSettings() {
  return typedHttp.get(PAYOUT_SETTINGS_ENDPOINT, {
    withAuth: true,
  });
}

export function fetchUserPaymentSettings({
  country,
}: { country?: string } = {}) {
  return typedHttp.get(PAYMENT_SETTINGS_ENDPOINT, {
    params: {
      country,
    },
    withAuth: true,
  });
}
